
/**
 * Products initial values for the redux state.
 */
export const INITIAL_STATE = {
  products: false,
  product:false,
  filter:false,
}
